import { render, staticRenderFns } from "./ti1.vue?vue&type=template&id=20658e6d&scoped=true&"
import script from "./ti1.vue?vue&type=script&lang=js&"
export * from "./ti1.vue?vue&type=script&lang=js&"
import style0 from "./ti1.vue?vue&type=style&index=0&id=20658e6d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20658e6d",
  null
  
)

export default component.exports